import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { Widget, Dashboard } from 'src/api/models'
import { StorageTablesService } from "src/service/storage-tables.service";
import { ApplicationConfigService } from "src/service/application-config.service";

@Component({
  selector: "app-control-panel-widget-editor",
  templateUrl: "./control-panel-widget-editor.component.html",
  styleUrls: ["./control-panel-widget-editor.component.css"],
})
export class ControlPanelWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: ChartWidget;
  public dashboard: Dashboard;
  public w: any;

  private colours: string[];

  constructor(public storageTablesService: StorageTablesService, public app: ApplicationConfigService) {
    this.colours = app.colours;
  }

  ngOnInit() {
    this.w = this.widget;
    console.log(this.w);
    if (this.w.detailList == null){
      this.w.detailList = [];
    }
    var i = 0;
    for (let tab of this.w.detailList) {
      tab.removable = true;
      if (tab.transforms == null){
        tab.transforms = [];
      }
      i++;
    }
  }

  public addTimeSeries() {
    this.w.detailList.push({
      uri: null,
      active: true,
      transforms: [],
      zoneColours: []
    });
  }

  public removeTimeSeries(timeSeries: any): void {
    var index = this.w.detailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.detailList.splice(index, 1);
    }
  }

  public addZoneColor(ts) {
    if(ts.zoneColours == null){
      ts.zoneColours = [];
    }
    ts.zoneColours.push({ min:0, max:0, colour: this.findPreviousColour(ts)});
  }

  public removeZoneColour(ts, zoneObj){
    var index = ts.zoneColours.indexOf(zoneObj);
    if (index > -1) {
      ts.zoneColours.splice(index, 1);
    }
  }

  private findPreviousColour(ts):string{
    let returnColour = this.colours[0];
    const index = ts.zoneColours.length -1;
    //if return default colour when the zoneColors has not existing item.
    if(index == -1) return returnColour;
    try { 
      returnColour = ts.zoneColours[index].colour;
      }catch (err){
      console.error(err);
      return returnColour;
    }
    return returnColour;
  }
  
}
